(function () {
    'use strict';

    angular
        .module('elogbooks.common.survey')
        .controller('SurveyRequestsListController', SurveyRequestsListController);

    SurveyRequestsListController.$inject = [
        '$state',
        '$stateParams',
        'surveyRequestCollectionResponse',
        'coreClientCollectionResponse',
        'regionCollectionResponse',
        'siteGroupCollectionResponse',
        'serviceProviderGroupCollectionResponse',
        '$translate',
        'sitesCollectionResponse',
        'selectedSiteResponse'
    ];

    function SurveyRequestsListController(
        $state,
        $stateParams,
        surveyRequestCollectionResponse,
        coreClientCollectionResponse,
        regionCollectionResponse,
        siteGroupCollectionResponse,
        serviceProviderGroupCollectionResponse,
        $translate,
        sitesCollectionResponse,
        selectedSiteResponse
    ) {
        var vm = this;
        vm.site = $state.params.siteId;
        vm.surveyRequests = surveyRequestCollectionResponse.surveyrequests;
        vm.surveyRequestResponse = surveyRequestCollectionResponse;
        vm.entityCount = surveyRequestCollectionResponse.count;
        vm.search = search;
        vm.sitesSelect = {};
        vm.siteStatus = {};
        const shouldAddSiteFilter = $state.current.name === "dashboard.user.surveys.list";
        const isSiteIdsClear = !$stateParams.siteIds || $stateParams.siteIds.length === 0;
        const isCoreClientsClear = !$stateParams.coreClients || $stateParams.coreClients.length === 0;
        const isSiteRegionsClear = !$stateParams.siteRegions || $stateParams.siteRegions.length === 0;

        vm.siteRegionSelect = {
            response: regionCollectionResponse,
            link: regionCollectionResponse ? regionCollectionResponse.getLink('self') : null,
            responseKeyPath: 'regions',
            disableOrdering: true,
            itemValuePath: 'name',
            itemHrefPath: 'id'
        };

        vm.coreClientSelect = {
            response: coreClientCollectionResponse,
            link: coreClientCollectionResponse ? coreClientCollectionResponse.getLink('self') : null,
            responseKeyPath: 'coreclients',
            itemValuePath: 'name',
            itemHrefPath: 'id'
        };

        vm.serviceProviderGroupSelect = {
            response: serviceProviderGroupCollectionResponse,
            link: serviceProviderGroupCollectionResponse ? serviceProviderGroupCollectionResponse.getLink('self') : null,
            responseKeyPath: 'groups',
            itemValuePath: 'id',
            itemTitlePath: 'name',
            loadmoreEnabled: true
        };

        vm.siteGroupSelect = {
            response : siteGroupCollectionResponse,
            link : siteGroupCollectionResponse ? siteGroupCollectionResponse.getLink('self') : null,
            responseKeyPath: 'sitegroups',
            itemValuePath: 'id',
            itemTitlePath: 'name',
            loadmoreEnabled: true
        };

        vm.pagePrefix = $stateParams.surveyPage ? 'survey' : null;

        if ($state.current.name === "dashboard.user.sites.list.details.surveys.active") {
            vm.title = $translate.instant('SURVEY_REQUESTS');
        } else {
            vm.title = $translate.instant('SURVEYS');
        }

        var statusOptions = [
            {
                title: $translate.instant('STATUS_ACTIVE'),
                value: 'active'
            },
            {
                title: $translate.instant('STATUS_INACTIVE'),
                value: 'inactive'
            },
            {
                title: $translate.instant('STATUS_PENDING'),
                value: 'pending'
            },
            {
                title: $translate.instant('STATUS_COMPLETED'),
                value: 'completed'
            },
            {
                title: $translate.instant('STATUS_AUTOCOMPLETED'),
                value: 'autocompleted'
            }
        ];

        if (sitesCollectionResponse) {
            vm.sitesSelect = {
                response: sitesCollectionResponse,
                link: sitesCollectionResponse ? sitesCollectionResponse.getLink('self') : null,
                responseKeyPath: 'sites',
                itemValuePath: 'name',
                itemHrefPath: 'id',
                mapValue: 'siteIds',
                disabled: $stateParams.selectedSiteResource,
                cacheItems: selectedSiteResponse ? [{value:selectedSiteResponse.name, href:selectedSiteResponse.id, object:selectedSiteResponse}] : null
            };
        }

        vm.siteStatus = {
            type: 'options',
            title: 'SITE_STATUS',
            value: $stateParams.siteStatus,
            options: [
                { title: $translate.instant('STATUS_ALL'), value: 'all' },
                { title: $translate.instant('STATUS_ACTIVE'), value: 'active' },
                { title: $translate.instant('STATUS_INACTIVE'), value: 'inactive' }
            ],
            clearValue: 'active',
            param: 'siteStatus'
        };

        vm.criteria = {
            ...(shouldAddSiteFilter && {
                siteIds: {
                type: 'autocompletemulti',
                multiple: true,
                title: 'SITES',
                value: $stateParams.siteIds ? $stateParams.siteIds : null,
                options: vm.sitesSelect,
                param: 'siteIds',
                isClear: isSiteIdsClear
            },
                siteStatus: vm.siteStatus
            }),
            siteRegions: {
                type: 'autocompletemulti',
                multiple: true,
                title: 'REGION',
                value: $stateParams.siteRegions ? $stateParams.siteRegions : null,
                options: vm.siteRegionSelect,
                param: 'siteRegions',
                isClear: isSiteRegionsClear
            },
            serviceProviderGroup: {
                type: 'jsonselectwidget',
                title: 'SERVICE_PROVIDER_GROUP',
                value: JSON.parse($stateParams.serviceProviderGroup),
                options: vm.serviceProviderGroupSelect,
                param: 'groups'
            },
            siteGroup: {
                type: 'jsonselectwidget',
                title: 'SITE_GROUP',
                value: JSON.parse($stateParams.siteGroup),
                options: vm.siteGroupSelect,
                param: 'sitegroups'
            },
            coreClients: {
                type: 'autocompletemulti',
                multiple: true,
                title: 'CORE_CLIENT',
                value: $stateParams.coreClients ? $stateParams.coreClients : null,
                options: vm.coreClientSelect,
                param: 'coreClients',
                isClear: isCoreClientsClear
            },

            serviceProviderName: { type: 'text', title: 'SERVICE_PROVIDER', value: $stateParams.serviceProviderName },
            surveyStatus: { type: 'options', multiple: true, title: 'STATUS', value: $stateParams.surveyStatus, options: statusOptions, clearValue: null},
            surveyName: { type: 'text', title: 'SURVEY', value: $stateParams.surveyName },
            scoreLessThan: { type: 'number', title: 'SCORE_LESS_THAN', value: parseInt($stateParams.scoreLessThan) || null, min: 1, max: 100, step: 1 },
            reportingPeriod: {
                type: 'month-year',
                title: 'REPORTING_PERIOD_MONTH_YEAR',
                value: $stateParams.reportingPeriod ? new Date($stateParams.reportingPeriod) : null,
                options: {
                    datepickerMode: 'month',
                    minMode: 'month',
                }
            }
        };

        function order (key) {
            $stateParams.order = key;

            $state.go('.', angular.extend({}, $stateParams), { reload: $state.current });
        }

        function search (params) {
            var override = {
                page: 1,
                surveyPage: 1
            };

            $state.go('.', angular.extend({}, params, override), { reload: $state.current });
        }

        function remove() {
            window.localStorage.removeItem('regionFilter');
        }

        function update() {
            window.localStorage.removeItem('regionFilter');
        }
    }
})();
